import { colors } from "@mui/material";

const MuiChip = {
	styleOverrides: {
		root: {
			// Default styling for chips without a color prop
		},
		colorDefault: {
			backgroundColor: colors.blueGrey[50],
			color: colors.blueGrey[900],
		},
		deletable: {
			"&:focus": {
				backgroundColor: colors.blueGrey[100],
			},
		},
	},
};
export default MuiChip;
